import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import apiMiddleware from 'Src/middleware/api';
import logger from 'redux-logger';
import createRootReducer from 'Src/reducers';

const isDevTools = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

const composeEnhancers = isDevTools ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const middlewares = [
  thunk,
  apiMiddleware,
];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
);
const reducer = createRootReducer();
const store = createStore(reducer, enhancer);

export default store;
